async function sendContactForm(event) {
    event.preventDefault();
  
    const form = document.querySelector('#contactForm');
    const buttonLoader = document.querySelector('#buttonLoader');
    const submitButton = form.querySelector('button[type="submit"]');
    const name = form.elements['contactFormName'].value.trim();
    const email = form.elements['contactFormEmail'].value.trim();
    const message = form.elements['contactFormMessage'].value.trim();
  
    if (!name || !email || !message) {
        console.error('Please fill all the required fields.');
        return;
    }
  
    const data = { name, email, message };
    buttonLoader.style.display = 'inline-block';  // Show button loader
    submitButton.disabled = true;  // Disable the button
    const functionKey = 'lGVmmomvfCjXWzkEszDKw0aaEX1OOyM8AVdgCkOvQaStAzFuQEPOjg==';
  
    try {
      const response = await fetch(`https://trfunctions.azurewebsites.net/api/contactFormFunction?code=${functionKey}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Origin': 'https://www.techrange.co',
            },
            body: JSON.stringify(data),
        });
  
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
  
        const responseData = await response.json();
        console.log('Success:', responseData);
        alert('Thank you for contacting us!');
        form.reset();
    } catch (error) {
        console.error('Error:', error);
        alert('Sorry, there was an error submitting the form. Please try again later.');
      } finally {
        buttonLoader.style.display = 'none';  // Hide button loader
        submitButton.disabled = false;  // Re-enable the button
    }
  }
  
  const contactForm = document.querySelector('#contactForm');
  contactForm.addEventListener('submit', sendContactForm);
  